import { Labels } from '../../shared-components/global/labels';

Labels.set('validation', 'input', 'Please enter a valid value.');
Labels.set('validation', 'date', 'Please enter a valid value.');
Labels.set('validation', 'time', 'Please enter a time.');
Labels.set('validation', 'range', 'Invalid input.');
Labels.set('validation', 'month', 'Please enter a valid month.');
Labels.set('validation', 'datetime-local', 'Please enter a datetime.');
Labels.set('validation', 'datetime-local', 'Ievadiet datumu.');
Labels.set('validation', 'custom', 'Validation custom error.');
Labels.set('validation', 'pattern', 'Please match the format.');
Labels.set(
    'validation',
    'rangeOverflow',
    'Value must be less than or equal %s.'
);
Labels.set(
    'validation',
    'rangeUnderflow',
    'Value must be greater than or equal %s.'
);
Labels.set(
    'validation',
    'step',
    'Step should be %s, nearest values are %s and %s.'
);
Labels.set(
    'validation',
    'long',
    'Value is too long, maximum length is %s symbols.'
);
Labels.set(
    'validation',
    'short',
    'Value is too short, minimum length is %s symbols.'
);
Labels.set('validation', 'type', 'Please enter a valid value.');
Labels.set('validation', 'email', 'Please enter an email address.');
Labels.set('validation', 'url', 'Please enter a URL.');
Labels.set('validation', 'value', 'Please fill out this field.');

// User defined rule validations
Labels.set('validation', 'matches', "Fields values don't match.");
Labels.set('validation', 'checkboxes', 'Please select at least %s option(s).');
Labels.set('validation', 'remote', 'Wrong response from server');
Labels.set('validation', 'maxfilesize', 'File size limit exceeded %s Kb.');
Labels.set(
    'validation',
    'requiredMultiple',
    'Please fill at least %s field(s).'
);
Labels.set('validation', 'onlyOneOf', 'Only one field is allowed');

// Example formats for pattern rule
Labels.set('validation', 'basicDateFormat', 'DD.MM.YYYY');
Labels.set(
    'validation',
    'alternativeDateFormat',
    'DD.MM.YYYY or D.M.YYYY or D.MM.YYYY'
);
Labels.set('validation', 'reverseDateFormat', 'YYYY.MM.DD');
Labels.set('validation', 'basicTimeFormat', 'HH:MM:SS');
Labels.set('validation', 'shortTimeFormat', 'HH:MM');
Labels.set('validation', 'digitsAmountFormat', '%s digits.');
Labels.set('validation', 'digitsAmountHardcodedFormat', '13-16 digits.');
Labels.set('validation', 'lettersAndNumbersFormat', 'Letters and numbers.');
Labels.set('validation', 'lettersOnlyFormat', 'Letters only.');
Labels.set('validation', 'numbersOnlyFormat', 'Numbers only.');
Labels.set(
    'validation',
    'decimalPointNumbersFormat',
    'Numbers with decimal points, e.g. 9.99 or 9,99.'
);
Labels.set(
    'validation',
    'startingDateBeforeEndingDate',
    'Starting date needs to be before the ending date.'
);
